export enum ProcessingStatus {
    Created = 1,

    GeneratedSuccessfully = 2,

    GenerationFailed = 3
}